import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import moment from "moment";
import { toast } from "react-toastify";
import CalculatePayrollComponent from "./CalculatePayrollComponent/CalculatePayrollComponent";
import { useNavigate } from "react-router-dom";

const CalculatePayroll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Calculate Payroll"));
  }, []);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    if (user.DefaultContactID) {
      setApprovedByValue(user.DefaultContactID)
      setUserName(user.DefaultContactID);
    }
  }, []);
  const intialFilterData = [
    { label: "Branch", value: { value: 2, label: "NSS-Main" } },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [payrollData, setPayrollData] = useState([]);
  const [editableColumnData, setEditableColumnData] = useState([]);
  const [payrollData1, SetPayrollData1] = useState([]);
  const [payrollData2, SetPayrollData2] = useState([]);
  const [filterFormData, setFilterData] = useState(intialFilterData);
  const [shiftOptlist, setShiftOptlist] = useState([]);
  const [departmentlist, setDepartmentlist] = useState([]);
  const [taxRegimelistset, setTaxRegimelist] = useState([]);
  const [designationOptList, setDesignationOptList] = useState([]);
  const [monthOptList, setMonthOptList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [branchOptList, setBranchOptList] = useState([]);
  const [approvedByOptions, setApprovedByOptions] = useState([]);
  const [financeSlab, setFinanceSlab] = useState([]);
  const [rebateSlab, setRebateSlab] = useState([]);
  const [jsVarData, setJSVarData] = useState([]);
  // console.log("jsVarData", jsVarData);

  const [payrollLinesData, setPayrollLinesData] = useState([]);

  const columns = [
    { key: "EmployeeCode", label: "Code", type: "Link", align: "center", visible: true },
    // { key: "Employee", label: "Employee", align: "center", visible: true },
    { key: "Employee", label: "Employee", align: "center", visible: true },
    {
      key: "PresentDays",
      label: "Present Days",
      align: "center",
      visible: true,
    }, { key: "AbsentDays", label: "Absent Days", align: "center", visible: true },

  ];

  const handleChange = (e, name) => {
    // Convert the date to "YYYY-MM" format if it's a valid date
    const formattedValue = moment(e, "DD-MMM-YYYY").isValid()
      ? moment(e, "DD-MMM-YYYY").format("YYYY-MM")
      : e;

    setFilterData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      let updatedFormData = [...prevFormData];

      if (existingLabelIndex !== -1) {
        updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? {
              ...item,
              value: formattedValue !== undefined ? formattedValue : e,
            }
            : item
        );
      } else {
        updatedFormData.push({
          label: name,
          value: formattedValue !== undefined ? formattedValue : e,
        });
      }

      // If "Month" is changed, auto-set "Tax Regime" value
      if (name === "Month") {
        const taxRegimeExists = updatedFormData.find(
          (item) => item.label === "Tax Regime"
        );

        if (!taxRegimeExists) {
          updatedFormData.push({
            label: "Tax Regime",
            value: { value: 6797, label: "New Regime" },
          });
        } else {
          updatedFormData = updatedFormData.map((item) =>
            item.label === "Tax Regime"
              ? { ...item, value: { value: 6797, label: "New Regime" } }
              : item
          );
        }
      }

      return updatedFormData;
    });
  };

  const formDatas = [
    { name: "Shift", type: "Select", options: [...shiftOptlist] },
    { name: "Department", type: "Select", options: [...departmentlist] },
    { name: "Tax Regime", type: "Select", options: [...taxRegimelistset] },
    { name: "Designation", type: "Select", options: [...designationOptList] },
    { name: "Month", type: "Select", options: [...monthOptList] },
    { name: "Employee", type: "Select", options: [...employeeList] },
    { name: "Branch", type: "Select", options: [...branchOptList] },
  ];

  const fetchPayrollMaster = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/calculate-payroll`
      );
      if (response.status === 200) {
        // Shift List
        const shiftList = response?.data?.shift?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setShiftOptlist(shiftList);
        // Department List
        const depList = response?.data?.department?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setDepartmentlist(depList);
        // Tax Regime List
        const taxlist = response?.data?.regime?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setTaxRegimelist(taxlist);
        // Designation List
        const designationlist = response?.data?.designation?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setDesignationOptList(designationlist);
        // Month List
        const monthlist = response?.data?.calendermonth?.map((tech) => ({
          value: tech.value,
          label: tech.text,
          MonthDiff: tech?.MonthDiff,
        }));
        setMonthOptList(monthlist);
        // Employee List
        const emplist = response?.data?.employeelist?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(emplist);
        // Branch List
        const branchlist = response?.data?.branches?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setBranchOptList(branchlist);
        const approvedlist = response?.data?.executives?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setApprovedByOptions(approvedlist);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  useEffect(() => {
    fetchPayrollMaster();
  }, []);

  const [apiStatus, SetApiStatus] = useState(202);
  const handleGetData = async () => {
    SetApiStatus(undefined);
    setPayrollData([])
    setFormattedKeys([])

    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/finance/employee-payroll?p_MonthID=${filterFormData.find((o) => o.label === "Month")
          ? filterFormData.find((o) => o.label === "Month").value.value
          : 0
        }&p_ShiftID=${filterFormData.find((o) => o.label === "Shift")
          ? filterFormData.find((o) => o.label === "Shift").value.value
          : 0
        }&p_DepartmentID=${filterFormData.find((o) => o.label === "Department")
          ? filterFormData.find((o) => o.label === "Department").value.value
          : ""
        }&p_DesignationID=${filterFormData.find((o) => o.label === "Designation")
          ? filterFormData.find((o) => o.label === "Designation").value.value
          : ""
        }&p_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value.value
          : 0
        }&p_TaxRegime=${filterFormData.find((o) => o.label === "Tax Regime")
          ? filterFormData.find((o) => o.label === "Tax Regime").value.value
          : 0
        }`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const PayRollNiceData = response?.data?.data;

        // const formattedPayrollData = PayRollNiceData?.map((item) => {
        //   const formatted = { ...item };
        //   for (const key in formatted) {
        //     const value = formatted[key];

        //     if (
        //       typeof value === "string" &&
        //       value.trim() !== "" &&
        //       !isNaN(value)
        //     ) {
        //       formatted[key] = parseFloat(value).toFixed(2);
        //     }
        //   }
        //   return formatted;
        // });

        setPayrollData(PayRollNiceData || []);


        setJSVarData(response?.data?.dataForJS);
        setFinanceSlab(response?.data?.financeSlab);
        setEditableColumnData(response?.data?.editable_payrolls || []);
        setRebateSlab(response?.data?.rebateSlab);


        setPayrollLinesData(response?.data?.payroll_data);

        const PayRollNiceData1 = response?.data?.attendanceleave;
        SetPayrollData1(PayRollNiceData1);
        const PayRollNiceData2 = response?.data?.attendanceIssueDetails;
        SetPayrollData2(PayRollNiceData2);
        // updateOtherPayrolls(PayRollNiceData)

      }
    } catch (error) { }
  };


  useEffect(() => {
    if (payrollData.length != 0 && payrollLinesData.length != 0) {
      updateOtherPayrolls(payrollData)
    }
  }, [payrollData, payrollLinesData])

  const roundOff = (value, level, roundValue) => {
    // Handle NaN and null cases
    if (isNaN(value) || value === null) return 0;

    const numericValue = parseFloat(value);
    const numericRoundValue = parseFloat(roundValue);

    // Basic rounding for non-special levels
    if (![278, 496, 497, 498].includes(parseInt(level))) {
      const factor = Math.pow(10, parseInt(level));
      return Math.round(numericValue * factor) / factor;
    }

    // Special rounding cases
    let totalPayable = numericValue;
    let roundResult = 0;

    if (numericValue > 0) {
      const decimalVal = numericValue % numericRoundValue;

      switch (parseInt(level)) {
        case 278: // Round to nearest multiple
          const diff = numericRoundValue - decimalVal;
          const autoVal = diff > decimalVal ? decimalVal : diff;

          if (numericRoundValue / 2 > decimalVal) {
            totalPayable = numericValue - autoVal;
            roundResult = -autoVal;
          } else {
            totalPayable = numericValue + autoVal;
            roundResult = autoVal;
          }
          break;

        case 496: // Always round up
          if (decimalVal > 0) {
            roundResult = numericRoundValue - decimalVal;
            totalPayable = numericValue + roundResult;
          } else {
            roundResult = decimalVal;
          }
          break;

        case 497: // Always round down
          if (decimalVal > 0) {
            roundResult = -decimalVal;
            totalPayable = numericValue + roundResult;
          } else {
            roundResult = decimalVal;
          }
          break;

        case 498: // No rounding
          break;

        default:
          break;
      }
    }

    // Store the rounding difference if needed elsewhere
    // (Remove if you don't need this global variable)
    // _RoundOffValue = isNaN(roundResult) ? 0 : roundResult;

    return isNaN(totalPayable) ? 0 : totalPayable;
  };

  // Helper function to safely check NaN
  const checkIsNaN = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const replaceAll = (str, find, replace) => {
    return str.replace(
      new RegExp(find.replace(/([.*+?^=!:${}()|\[\]/\\])/g, "\\$&"), "g"),
      replace
    );
  };

  const updateOtherPayrolls = (grid) => {
    let gridData = grid;
    let payrolls = payrollLinesData;
    let gross = "$" + jsVarData.gross_sal.replace(" ", "_");
    let net = "$" + jsVarData.net_sal.replace(" ", "_");

    let amt = 0;
    let gross_formula = '';
    let gross_round_level = jsVarData?.gross_round_level;
    let gross_round_val = jsVarData?.gross_round_val;

    // console.log("gridData", gridData);
    // console.log("payrolls::::", payrolls);

    gridData.forEach(function (row) {
      row[gross] = 0;
      row[net] = 0;
      row.TotalDeductions = 0;

      /// gross
      Object.entries(payrolls).forEach(([key, value]) => {
        // console.log("Object.entries(payrolls).forEach", key, value);

        let tmpFormula = '0';
        // console.log("this.payrolltype", value.PayrollType_054);

        if (
          value.PayrollType_054 == '239' ||
          value.PayrollType_054 == '244' ||
          value.PayrollType_054 == '1025' ||
          value.PayrollType_054 == '1183' ||
          value.PayrollType_054 == '619'
        ) {
          // console.log(
          //   "checkIsNaN(row[key]),parseInt(value.RoundOffLevel_035),parseFloat(value.RoundOffValue)",
          //   checkIsNaN(row[key]),
          //   parseInt(value.RoundOffLevel_035),
          //   parseFloat(value.RoundOffValue)
          // );
          amt = roundOff(
            checkIsNaN(row[key]),
            parseInt(value.RoundOffLevel_035),
            parseFloat(value.RoundOffValue)
          );
          // console.log("amt:::", amt);
          row[net] += amt;
        }

        // console.log("jsVar.gross_formula", jsVarData.gross_formula);
        gross_formula = jsVarData.gross_formula;
        // console.log("gross_formula::::", gross_formula);

        // console.log(
        //   "TestEval",
        //   eval(
        //     jsVarData.gross_formula
        //       .replace(/if/g, '')
        //       .replace(/\s+/g, '')
        //       .replace('[' + value.Code + ']', amt)
        //       .replace(/\[.+?\]/g, 0)
        //   )
        // );

        row[gross] += eval(
          gross_formula
            .replace(/if/g, '')
            .replace(/\s+/g, '')
            .replace('[' + value.Code + ']', amt)
            .replace(/\[.+?\]/g, 0)
        );
      });

      // console.log(
      //   "row[gross],gross_round_level,gross_round_val",
      //   row[gross],
      //   gross_round_level,
      //   gross_round_val
      // );

      row[gross] = roundOff(row[gross], gross_round_level, gross_round_val);
      // deduction
      Object.entries(payrolls).forEach(([key, value]) => {
        var tmpFormula = '0';

        // console.log("line 384:this.payrolltype", value.PayrollType_054);

        if (
          value.PayrollType_054 == '237' ||
          value.PayrollType_054 == '238' ||
          value.PayrollType_054 == '243' ||
          value.PayrollType_054 == '1028' ||
          value.PayrollType_054 == '1166' ||
          value.PayrollType_054 == '1274' ||
          value.PayrollType_054 == '941'
        ) {
          // console.log("line 400 value.IsCalculatedOnRunTime", value.IsCalculatedOnRunTime);

          if (
            value.PayrollType_054 == '1166' ||
            (value.IsCalculatedOnRunTime != '1' && value.PayrollType_054 != '941')
          ) {
            // console.log("in if 1st if:");
            // console.log(
            //   "line 40333:",
            //   checkIsNaN(row[key]),
            //   parseInt(value.RoundOffLevel_035),
            //   parseFloat(value.RoundOffValue)
            // );

            amt = roundOff(
              checkIsNaN(row[key]),
              parseInt(value.RoundOffLevel_035),
              parseFloat(value.RoundOffValue)
            );

            // console.log("line 407: amt", amt);

            row[net] -= amt;
            row.TotalDeductions -= amt;
          } else if (
            value.PayrollType_054 == '941' &&
            value.IsCalculatedOnRunTime == '1'
          ) {
            // console.log(" in 2nd if:");
            // console.log(
            //   "line 413:",
            //   calculateUsingFormula(value.Formula, row, payrolls),
            //   parseInt(value.RoundOffLevel_035),
            //   parseFloat(value.RoundOffValue)
            // );

            row[key] = roundOff(
              calculateUsingFormula(value.Formula, row, payrolls),
              parseInt(value.RoundOffLevel_035),
              parseFloat(value.RoundOffValue)
            );
          } else if (value.PayrollType_054 != '941' && row[key] != undefined) {
            // console.log("line 418 in 3rd if:");
            // console.log(
            //   "line 419:",
            //   calculateUsingFormula(value.Formula, row, payrolls),
            //   parseInt(value.RoundOffLevel_035),
            //   parseFloat(value.RoundOffValue)
            // );
            if (value.PayrollType_054 == '238' && row['gender'] == 'female'&& value.ID == 10) {

              if (row['$Gross_Salary'] <= 25000 ) {

                amt = roundOff(
                  calculateUsingFormula("0", row, payrolls, value.PayrollType_054),
                  parseInt(value.RoundOffLevel_035),
                  parseFloat(value.RoundOffValue)
                );

                console.log("line 423: amt", amt);

                row[key] = amt;
                row[net] -= amt;
                row.TotalDeductions -= amt;
                console.log("name:::::", row['Employee'], row['$Gross_Salary']);
              }else {
              amt = roundOff(
                calculateUsingFormula(value.Formula, row, payrolls, value.PayrollType_054),
                parseInt(value.RoundOffLevel_035),
                parseFloat(value.RoundOffValue)
              );

              console.log("line 423: amt", amt);

              row[key] = amt;
              row[net] -= amt;
              row.TotalDeductions -= amt;
            }

            } else {
              amt = roundOff(
                calculateUsingFormula(value.Formula, row, payrolls, value.PayrollType_054),
                parseInt(value.RoundOffLevel_035),
                parseFloat(value.RoundOffValue)
              );

              console.log("line 423: amt", amt);

              row[key] = amt;
              row[net] -= amt;
              row.TotalDeductions -= amt;
            }
          }




        }
      });

      // console.log("line 431 row", row);
    });

    // console.log("line 432 updated grid", grid);
    return gridData;
  };

  const calculateUsingFormula = (formula, row, payrolls, PayrollType_054) => {
    console.log("line 437: formula, row, payrolls", formula, row, payrolls, PayrollType_054);

    let code = '';
    formula = formula.replace(/if/g, '').replace(/\s+/g, '');

    while ((code = formula.match(/\[\w+\]/))) {
      let code1 = '';
      Object.entries(payrolls).forEach(([key, value]) => {
        if (value.Code == code[0].replace(/\[/, '').replace(/\]/, '')) {
          // console.log("line 448: in if ");
          code1 = key;
          return false; // break
        }
      });

      // console.log("line 454:", formula, code[0], checkIsNaN(row[code1]));

      formula = replaceAll(formula, code[0], checkIsNaN(row[code1]));

      // console.log("line 457: formula", formula);
    }

    // console.log("line 457: checkIsNaN(eval(formula))", checkIsNaN(eval(formula)));
    return checkIsNaN(eval(formula));
  };


  const [payrollTaxDetailsArray, setPayrollTaxDetailsArray] = useState([]);

  const calculateTDS = () => {
    const selectedMonth = filterFormData.find((o) => o.label === "Month")?.value?.value;
    const monthsPending = monthOptList.find((o) => o.value === selectedMonth)?.MonthDiff + 1 || 0;

    if (!monthsPending || financeSlab.length === 0) {
      toast.error("Income tax slab not defined or invalid month selection");
      return [];
    }

    const payroll_tax_details = [];
    const updatedPayrollData = [...payrollData];

    const gross = jsVarData.gross_sal?.replace(" ", "_") || "";
    const tds = jsVarData.tds_payroll?.replace(" ", "_") || "";

    payrollData.forEach((employee, rowIndex) => {
      // if (employee.joiningDate && moment(employee.joiningDate).isValid()) {
      //     const joiningDate = moment(employee.joiningDate);
      //     const currentDate = moment();
      //     if (joiningDate.month() === currentDate.month() && 
      //         joiningDate.year() === currentDate.year()) {
      //         return;
      //     }
      // }

      const numericFields = [
        'TotalMonthlyEarn', 'cumulative_total', 'ExcemptionAmount',
        'IncomeFromOtherSource', 'PaidIncomeTax', 'ActualGross'
      ];

      // Convert fields to numbers with legacy parsing
      const values = {};
      numericFields.forEach(field => {
        values[field] = parseFloat(employee[field] || 0);
      });

      // Match legacy calculation flow
      const Projected_Gross = values.ActualGross * (monthsPending - 1);
      const Total_Gross = values.cumulative_total + values.TotalMonthlyEarn + Projected_Gross;
      const Taxable_Amt = Math.max(0, Total_Gross + values.IncomeFromOtherSource - values.ExcemptionAmount);

      // Legacy slab calculation method
      let calAmt = 0;
      let calTaxAmt = 0;
      let calSlabAmt = 0;

      financeSlab.forEach((slab) => {
        const minAmt = parseFloat(slab.MinAmt) || 0;
        const maxAmt = parseFloat(slab.MaxAmt) || 0;
        const perc = parseFloat(slab.Perc) || 0;

        if (Taxable_Amt > minAmt) {
          calSlabAmt = calSlabAmt + calAmt;

          if (Taxable_Amt > maxAmt && maxAmt > 0) {
            calAmt = maxAmt - minAmt;
          } else {
            calAmt = (Taxable_Amt - calAmt) - minAmt;
          }

          calTaxAmt += Math.ceil((calAmt * perc) / 100);
        }
      });

      // Legacy rebate calculation
      let cessTax = 0;
      let totalTDS = calTaxAmt;
      let b4Rebate = totalTDS;
      let _rebateExmptAmt = 0;

      if (rebateSlab[0]) {
        if (Taxable_Amt <= parseFloat(rebateSlab[0].TaxRebateLimit)) {
          _rebateExmptAmt = parseFloat(rebateSlab[0].TaxRebateExcemtion) || 0;

          if (totalTDS >= _rebateExmptAmt) {
            totalTDS = totalTDS - _rebateExmptAmt;
          } else {
            totalTDS = 0;
          }
        }
      }

      let b4Cess = totalTDS;
      // console.log("totalTDS line 633", totalTDS);

      let cal_surcharge_yearly = 0
      if (Taxable_Amt > 5000000 && Taxable_Amt < 10000000) {
        cal_surcharge_yearly = Math.ceil(totalTDS * 10 / 100)
        totalTDS = (totalTDS + Math.ceil(totalTDS * 10 / 100))
      } else if(Taxable_Amt > 10000000 && Taxable_Amt < 20000000) {
        cal_surcharge_yearly = Math.ceil(totalTDS * 15 / 100)
        totalTDS = (totalTDS + Math.ceil(totalTDS * 15 / 100))
      }
      // console.log("cal_surcharge_yearly", cal_surcharge_yearly);

      // console.log("totalTDS after Surcharge", totalTDS);

      if (rebateSlab[0]) {
        cessTax = Math.ceil((totalTDS * parseFloat(rebateSlab[0].TaxEducationCESS)) / 100);
        totalTDS += cessTax;
      }

      // console.log("totalTDS after edcess", totalTDS);

      totalTDS = Math.max(totalTDS - values.PaidIncomeTax, 0);
      let monthlyTDS;
      monthlyTDS = totalTDS > 0 ? Math.round(totalTDS / monthsPending) : 0;



      // Update employee data
      const updatedEmployee = { ...employee };
      if (tds && updatedEmployee[tds] !== undefined && totalTDS > 0) {
        updatedEmployee[tds] = monthlyTDS;
      }
      updatedEmployee.$TDS = monthlyTDS;
      updatedPayrollData[rowIndex] = updatedEmployee;


      payroll_tax_details.push({
        TXNID: employee.TXNID,
        EmployeeID: employee.ContactID,
        MonthID: selectedMonth,
        Employee: employee.Employee,
        NetTaxableIncome: Taxable_Amt,
        IncomeTaxOnTotalIncomePayable: b4Cess,
        RebateUnderSection87: _rebateExmptAmt,
        TotalTaxDue: b4Cess,
        SurchargeOnIncomeTax: cal_surcharge_yearly || 0,
        EducationCess: cessTax,
        TotalIncomeTaxAndSCAndCessPayable: b4Cess + cessTax + cal_surcharge_yearly,
        LessTaxDeductedTillDate: values.PaidIncomeTax,
        Balance: totalTDS,
        AvgMonthlyTaxAndSCAndCessToBeRecovered: monthlyTDS
      });
    });


    // Update state and sync resources
    const updatedData = updateOtherPayrolls(updatedPayrollData);
    setPayrollData(updatedData);
    setPayrollTaxDetailsArray(payroll_tax_details);
    // console.log("payroll_tax_details", payroll_tax_details);

    setSelectedResources((prev) =>
      prev.map((resource) => {
        const updated = updatedData.find((emp) => emp.ContactID === resource.ContactID);
        return updated ? { ...updated, tmpIsAllowed: 1 } : resource;
      })
    );

    toast.success("TDS Calculated Successfully");
    return payroll_tax_details;
  };
  const handleEditableColumnChange = (event, name, rowIndex, contactID) => {
    const input = event.target;
    let newValue = input.value;
    // Handle empty or null values by setting them to null in state
    if (newValue === null || newValue === "") {
      setPayrollData((prevData) => {
        const newData = prevData.map((row, index) =>
          index === rowIndex ? { ...row, [name]: null } : row
        );
        updateOtherPayrolls(newData);
        return newData;
      });

      setSelectedResources((prevSelectedResources) => {
        if (selectedItems[contactID]) {
          return prevSelectedResources.map((resource) =>
            resource.ContactID === contactID
              ? { ...resource, [name]: null }
              : resource
          );
        }
        return prevSelectedResources;
      });
      return;
    }

    const numericValue = checkIsNaN(parseFloat(newValue));
    const roundOffLevel =
      parseInt(payrollLinesData[name]?.RoundOffLevel_035) || 0;
    const roundOffValue =
      parseFloat(payrollLinesData[name]?.RoundOffValue) || 0;

    let processedValue = roundOff(numericValue, roundOffLevel, roundOffValue);

    // Fix floating-point precision
    processedValue = Number.isInteger(processedValue)
      ? parseInt(processedValue)
      : parseFloat(processedValue.toFixed(Math.min(8, roundOffLevel)));

    // Update payroll data and THEN call updateOtherPayrolls with the new value
    setPayrollData((prevData) => {
      const newData = prevData.map((row, index) =>
        index === rowIndex ? { ...row, [name]: processedValue } : row
      );
      updateOtherPayrolls(newData);
      return newData;
    });

    // Update selected resources
    setSelectedResources((prevSelectedResources) => {
      if (selectedItems[contactID]) {
        return prevSelectedResources.map((resource) =>
          resource.ContactID === contactID
            ? { ...resource, [name]: processedValue }
            : resource
        );
      }
      return prevSelectedResources;
    });
  };

  const [formattedKeys, setFormattedKeys] = useState([]);
  const [totals, setTotals] = useState({});


  /**
   *  Modified on 27-06-2025 below UseEffet
   * This function stores the columns in a specific sequence, matching the previous format used by Rujul.
   * It filters the column keys, removes the "$" symbol, and maps them into a formatted structure.
   */

  useEffect(() => {
    if (payrollData.length > 0) {
      const extractedKeys = [];

      // Extract all keys from first row of data
      Object.keys(payrollData[0]).forEach((key) => {
        if (key.startsWith("$")) {
          const label = key.replace("$", "").replace(/_/g, " ");
          extractedKeys.push({
            key: key,
            label,
            align: "center",
            visible: true,
          });
        }
      });

      // Add Total Deductions manually
      extractedKeys.push({
        key: "TotalDeductions",
        label: "Total Deductions",
        align: "center",
        visible: true,
      });

      // Predefined column sequence
      const columnSequence = [
        "tmpIsAllowed",
        "EmployeeCode",
        "Employee",
        "PresentDays",
        "AbsentDays",
        "$Basic",
        "$HRA",
        "$Professional_Development_Allowance", // Spl_Allow
        "$Conv_Allow",
        "$NPS",
        "$Leave_Travel_Allowance",
        "$Gross_Salary",
        "$Leave_Encashment",
        "$Consulting_Incentives",
        "$Content_Incentives",
        "$Training_Incentives",
        "$Revenue_Incentives",
        "$HR_Incentives",
        "$Incentives",
        "$Sales_Incentive",
        "$Team_Incentive",
        "$Account_Management_Incentive",
        "$Project_Incentives",
        "$Annual_Performance_Bonus",
        "$CCA",
        "$Bonus",
        "$PFDIR1", // Added missing columns
        "$Other_Allowance",
        "$Referral_Bonus",
        "$Arrears",
        "$Reimbursement_deduction",
        "$PT",
        "$NPS_Deduction",
        "$TDS",
        "$Provident_Fund",
        "$Voluntary_Provident_Fund",
        "$Other_Deduction",
        "$Advance",
        "$Gratuity",
        "$Mediclaim_Insurance",
        "$Night_Shift_Allowance",
        "$Recoveries",
        "$Statutory_Bonus",
        "TotalDeductions",
        "$Net_Salary",
      ];

      // Combine static columns + dynamic payroll columns
      const staticColumns = [
        { key: "EmployeeCode", label: "Code", type: "Link", align: "start", visible: true },
        { key: "Employee", label: "Employee", align: "center", visible: true },
        { key: "PresentDays", label: "Present Days", align: "center", visible: true },
        { key: "AbsentDays", label: "Absent Days", align: "center", visible: true },
      ];

      const allDynamicCols = [...extractedKeys];

      // Merge static and dynamic into a map for quick lookup
      const allColsMap = [...allDynamicCols].reduce((acc, col) => {
        acc[col.key] = col;
        return acc;
      }, {});

      // Sort final columns according to predefined sequence
      const sortedCols = columnSequence
        .filter((key) => allColsMap[key]) // Only include existing keys
        .map((key) => allColsMap[key]);

      setFormattedKeys(sortedCols);
    }
  }, [payrollData]);


  const [editableFormattedKeys, setEditableFormattedKeys] = useState([]);

  useEffect(() => {
    if (editableColumnData.length > 0) {
      const extractedKeys = [];

      // Extract and format keys dynamically that start with "$"
      editableColumnData.forEach((key) => {
        if (key.startsWith("$")) {
          const newKey = key.replace("$", "").replace(/_/g, " "); // Format key
          extractedKeys.push({ key: key, label: newKey });
        }
      });

      setEditableFormattedKeys(extractedKeys);
    }
  }, [editableColumnData]);

  useEffect(() => {
    if (payrollData.length > 0) {
      const sums = {};

      formattedKeys.forEach(({ key }) => {
        sums[key] = payrollData.reduce(
          (acc, item) => acc + (Number(item[key]) || 0),
          0
        );
      });

      setTotals(sums);
    }
  }, [payrollData, formattedKeys]);


  const dataSets = {
    "Calculate Payroll": payrollData,
    "Attendance/Leave Issues": payrollData1,
    "Other Issues": payrollData2,
  };

  const columnHeadersMap = {
    "Calculate Payroll": [...columns, ...formattedKeys], // ✅ Merging formatted keys with columns
    "Attendance/Leave Issues": [
      { key: "Employee", label: "Employee Code" },
      { key: "Employee", label: "Employee" },
      { key: "Message", label: "Details" },
    ],
       "Other Issues": [
      { key: "EmployeeName", label: "Employee Name" },
      { key: "DaysMarked", label: "Attendance Marked" },
      { key: "DaysConfirmed", label: "Attendance Approved" },
      { key: "AttendanceStatus", label: "Details" },
    ],
  };

  const [newSelectedStatus, setNewSelectedStatus] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);
  const [approvedByValue, setApprovedByValue] = useState(null);

  const handleColumnSelect = (selectedOption, item, columnName) => {
    setPayrollData((prevData) =>
      prevData.map((row) =>
        row.ContactID === item.ContactID
          ? { ...row, [columnName]: Number(selectedOption.value).toFixed(4) }
          : row
      )
    );

    setSelectedItem(item);
    setNewSelectedStatus(Number(selectedOption.value).toFixed(4));

    setSelectedResources((prevResources) =>
      prevResources.map((resource) =>
        resource.ContactID === item.ContactID
          ? {
            ...resource,
            [columnName]: Number(selectedOption.value).toFixed(4),
          }
          : resource
      )
    );
  };

  const checkBoxRequiredMap = {
    "Calculate Payroll": true, // Checkbox required
    "Attendance/Leave Issues": false, // Checkbox not required
    "Other Issues": false, // Checkbox not required
  };


  const [submitButton, setSubmitButton] = useState(false);

  const handleSubmitButton = async () => {
    setSubmitButton(true)
    if (!approvedByOptions?.some(o => o.value === userName)) {
      toast.error("Please select Executive")
      setSubmitButton(false)
      return
    }
    if (selectedResources.length === 0) {
      toast.error("Please select at least one employee", {
        position: "top-right",
      });
      return; // Exit the function early if no employees are selected
    }
    try {
      const filterValue = (label) => {
        const item = filterFormData.find((o) => o.label === label);
        return item ? item.value.value : 0;
      };

      let response = await PostServiceCaller(
        `${API_URL}rujul/finance/calculate-payroll`,
        {
          FilterData: {
            p_Month: filterValue("Month"),
            p_ShiftID: filterValue("Shift"),
            p_DepartmentID: filterValue("Department")
              ? moment(filterValue("Department"))
              : "",
            p_DesignationID: filterValue("Designation")
              ? moment(filterValue("Designation"))
              : "",
            p_EmployeeID: filterValue("Employee"),
            p_TaxRegime: filterValue("Tax Regime"),
            p_ExecutiveID: approvedByValue,
          },
          CalculatePayrollLine: selectedResources,
          PayrollTaxDetail: selectedResources?.flatMap(el =>
            payrollTaxDetailsArray.filter(o => el.ContactID == o.EmployeeID)
          ),
          Employee: [
          ...payrollData1.map(item => ({
          EmployeeID: item.EmployeeID,
          Message: item.Message
          })),
          ...payrollData2.map(item => ({
          EmployeeID: item.EmployeeID,
          Message: item.AttendanceStatus
          }))
        ]

        },
        "post"
      );

      if (response?.status === 200) {
        setSubmitButton(false)
        toast.success("Data Submitted Successfully ", {
          position: "top-right",
        });
        setTimeout(() => {
          // handleGetData();
          handleReset()


        }, 1000);
      }
    } catch (error) {
      console.error("Error while posting:", error);
    }
  };
   const sendIssueMailToEmployee = async () => {
    try {
      let response = await PostServiceCaller(
        `${API_URL}rujul/finance/payroll-employeeissue-data/false`,
        {
          Employee: [
            ...payrollData1.map(item => ({
              EmployeeID: item.EmployeeID,
              Message: item.Message
            })),

            ...payrollData2.map(item => ({
              EmployeeID: item.EmployeeID ,
              Message: item.AttendanceStatus
            }))
          ]
        },
        "post"
      );

      if (response?.status === 200) {
        toast.success("Mail sent successfully!");
      }
    } catch (error) {
      console.error("Error sending mail:", error);
    }
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);

    const newSelectedItems = {};
    const newSelectedResources = checked
      ? payrollData.map((item) => ({ ...item, tmpIsAllowed: 1 })) // Set tmpIsAllowed to 1
      : [];

    if (checked) {
      payrollData.forEach((item) => {
        newSelectedItems[item.ContactID] = true;
      });
    }

    setSelectedItems(newSelectedItems);
    setSelectedResources(newSelectedResources);
  };

  const handleCheckboxChange = (e, id, item) => {
    const isChecked = e.target.checked;

    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = {
        ...prevSelectedItems,
        [id]: isChecked,
      };

      const allSelected =
        Object.keys(updatedSelectedItems).length === payrollData.length &&
        Object.values(updatedSelectedItems).every(Boolean);
      setSelectAllChecked(allSelected);

      return updatedSelectedItems;
    });

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, { ...item, tmpIsAllowed: 1 }]; // Set tmpIsAllowed to 1
      } else {
        return prevSelectedResources
          .map((resource) =>
            resource.ContactID === item.ContactID
              ? { ...resource, tmpIsAllowed: 0 }
              : resource
          )
          .filter((resource) => resource.ContactID !== item.ContactID);
      }
    });
  };

  const handleApprovedByChange = (selectedOptions) => {
    setApprovedByValue(selectedOptions.value);
  };

  const hanldeLinkColumn = (col, row) => {
    navigate('/employee-list/rujul/view/' + row.ContactID);
  }


  const handleReset = () => {
    setFilterData(intialFilterData)
    setPayrollData([])
    SetPayrollData1([])
    setFormattedKeys([])
    setSelectAllChecked(false)
    setSelectedResources([])
    setSelectedItems([])
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="rounded bg-white" id="skill-table-area">
          <div className="row">
            <CalculatePayrollComponent
              dataSets={dataSets}
              columnHeadersMap={columnHeadersMap}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              isSubmitStatus={submitButton}
              isFilterRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              handleReset={handleReset}
              isCheckBoxRequired={true}
              formattedKeys={formattedKeys}
              totals={totals}
              hanldeLinkColumn={hanldeLinkColumn}
              handleSubmitButton={handleSubmitButton}
              handleColumnSelect={handleColumnSelect}
              selectedResource={selectedResources}
              selectAllChecked={selectAllChecked}
              handleCheckboxChange={handleCheckboxChange}
              handleSelectAllChange={handleSelectAllChange}
              formDatas={formDatas}
              setSearchTerm={setSearchTerm}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              checkBoxRequiredMap={checkBoxRequiredMap}
              handleChange={handleChange}
              editableColumn={editableFormattedKeys}
              handleEditableColumnChange={handleEditableColumnChange}
              handleTDSCalculate={calculateTDS}
              ApprovedBYOptions={approvedByOptions}
              handleApprovedByChange={handleApprovedByChange}
              userName={userName}
              SendIssueMail={sendIssueMailToEmployee}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CalculatePayroll;
